import s from './Footer.module.css';
const LINKS = ['Skills','Projects','Experience','Contact'];
export default function Footer() {
  return (
    <footer className={s.footer}>
      <div className={s.inner}>
        <span className={s.logo}>Yosry Mlika</span>
        <nav className={s.links}>
          {LINKS.map(l => <a key={l} href={`#${l.toLowerCase()}`} className={s.link}>{l}</a>)}
        </nav>
        <span className={s.copy}>© {new Date().getFullYear()} · Dubai, UAE</span>
      </div>
    </footer>
  );
}
